import { Typography } from "@braintrust/braintrust-ui-components";
import { RouterLink } from "@js/components/link";

export const reviewInvoicingAction = {
  header: "Review how invoicing works",
  subheader:
    "Make sure you have all the information you need to submit your first invoice",
  description: (
    <>
      <p>
        You will submit invoices on the Braintrust platform through{" "}
        <Typography
          component="link"
          size="medium"
          variant="paragraph"
          color="primary"
          RouterLink={RouterLink}
          to="/talent/invoices"
          rel="noopener noreferrer"
          target="_blank"
          fontWeight={500}
        >
          this
        </Typography>{" "}
        portal.
      </p>
      <p>
        Our{" "}
        <a
          href={SETTINGS.SUPPORT_URLS.TALENT_FAQ_ARTICLE_URL}
          rel="noopener noreferrer"
          target="_blank"
          style={{ textDecoration: "underline", fontWeight: "500" }}
        >
          FAQ
        </a>{" "}
        is the best place to start with questions on how invoicing works on
        Braintrust.
      </p>
      <p>
        If you have any questions about payment terms or invoices - please reach
        out to us first!
      </p>
    </>
  ),
};

export const reviewPaymentTermsAction = {
  header: "Review payment terms",
  subheader:
    "Review terms and conditions, payment terms and frequency for this job",
  description: (
    <>
      <p>
        You are entering into a contract with Braintrust and Braintrust pays
        your invoices as soon as the client pays.
      </p>
      <p>
        When your invoice is paid, it has to go through our partner, Wise in
        order to get into your account. Wise takes 7-10 days, but sometimes this
        happens sooner.
      </p>
      <p>
        When you joined Braintrust, you signed up for our Terms and Conditions,
        which are applicable to this contract. Please review{" "}
        <a
          href={SETTINGS.TERMS_DOC_URL}
          rel="noopener noreferrer"
          target="_blank"
          style={{ textDecoration: "underline", fontWeight: 500 }}
        >
          here
        </a>
        .
      </p>
    </>
  ),
};
